"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookItemConverterImpl_1 = require("../../core/model/codebook/conversions/CodebookItemConverterImpl");

var PromotionTypes_1 = require("../model/PromotionTypes");

var PromotionTypeConverter_1 = require("./PromotionTypeConverter");
/**
 * Default implementation of PromotionTypeConverter.
 *
 * @author ZSr
 */


var PromotionTypeConverterImpl =
/*#__PURE__*/
function (_PromotionTypeConvert) {
  _inherits(PromotionTypeConverterImpl, _PromotionTypeConvert);

  function PromotionTypeConverterImpl() {
    var _this;

    _classCallCheck(this, PromotionTypeConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionTypeConverterImpl).call(this));
    _this.codebookItemConverter = new CodebookItemConverterImpl_1.CodebookItemConverterImpl();
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PromotionTypeConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var codebookItem = this.codebookItemConverter.toObject(source, conversions);
      return new PromotionTypes_1.PromotionTypes(PromotionTypes_1.PromotionTypes.schema.id.valueOf(conversions.documentToClassId(source)), PromotionTypes_1.PromotionTypes.schema.title.valueOfField(source), PromotionTypes_1.PromotionTypes.schema.externalId.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var document = {};
      Object.assign(document, this.codebookItemConverter.toDocument(source, conversions));
      Object.assign(document, {
        id: source.id,
        title: source.title,
        externalId: source.externalId
      });
      return document;
    }
  }]);

  return PromotionTypeConverterImpl;
}(PromotionTypeConverter_1.PromotionTypeConverter);

exports.PromotionTypeConverterImpl = PromotionTypeConverterImpl;